import {FocusMonitor} from '@angular/cdk/a11y';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, ElementRef, Input, OnDestroy, Optional, Self} from '@angular/core';
import {FormBuilder, FormGroup, ControlValueAccessor, NgControl} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {Subject} from 'rxjs';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ExpertiseService } from '../../shared/services/expertise.service';
import {FormControl} from '@angular/forms';
import {debounceTime, switchMap, tap} from 'rxjs/operators';
import { Expertise } from '../../shared/models/expertise';
/** Custom `MatFormFieldControl` for telephone number input. */
@Component({
  selector: 'app-expertise-input',
  templateUrl: 'expertise-input.component.html',
  styleUrls: ['expertise-input.component.scss'],
   providers: [        
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ExpertiseInputComponent,
            multi: true,
        }
    ]  

})
export class ExpertiseInputComponent implements ControlValueAccessor {

	@Input() placeholder: string;
	@Input() errors: string;
  stateCtrl = new FormControl();
  filteredExpertises: any;
	id: number;
  expertise: any; 

	constructor(
      private expertiseService: ExpertiseService
	) { 

      this.filteredExpertises = this.stateCtrl
          .valueChanges
          .pipe(
              debounceTime(300),
              tap(value => this.propagateChange(value)),
              switchMap(value => {
                 console.log(value);
                return this.expertiseService.getAllLight('name', 2, {'expertise->number': {value:value}},0,20);
              }),

           );
  }
 
  	propagateChange = (_: any) => {};
  	
  	ngOnInit() {        
  	}
    displayFn(expertise?: Expertise): string | undefined {
      return expertise ? expertise.number + ' - ' + expertise.name : undefined;
    }

  	onChange(event) {
  		console.log(event);
  		this.propagateChange(event.value);
  	}

    writeValue(obj: any): void {      
    	this.stateCtrl.patchValue(obj);
    	
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;        
    }

    registerOnTouched(fn: any): void { }

    setDisabledState?(isDisabled: boolean): void { }
}